import formatMoney from './formatMoney';

export default formatMoney;
